export interface OpacityOption {
  title: string;
  sharpCharts2AlphaValue: string;
};

export const OPACITY_OPTION_AUTO: OpacityOption = {
  title: '- Auto -',
  sharpCharts2AlphaValue: ''
};

export const OPACITY_OPTION_ONE_POINT_ZERO: OpacityOption = {
  title: '1.0',
  sharpCharts2AlphaValue: '1.0'
};

export const OPACITY_OPTION_ZERO_POINT_NINE: OpacityOption = {
  title: '0.9',
  sharpCharts2AlphaValue: '0.9'
};

export const OPACITY_OPTION_ZERO_POINT_EIGHT: OpacityOption = {
  title: '0.8',
  sharpCharts2AlphaValue: '0.8'
};

export const OPACITY_OPTION_ZERO_POINT_SEVEN: OpacityOption = {
  title: '0.7',
  sharpCharts2AlphaValue: '0.7'
};

export const OPACITY_OPTION_ZERO_POINT_SIX: OpacityOption = {
  title: '0.6',
  sharpCharts2AlphaValue: '0.6'
};

export const OPACITY_OPTION_ZERO_POINT_FIVE: OpacityOption = {
  title: '0.5',
  sharpCharts2AlphaValue: '0.5'
};

export const OPACITY_OPTION_ZERO_POINT_FOUR: OpacityOption = {
  title: '0.4',
  sharpCharts2AlphaValue: '0.4'
};

export const OPACITY_OPTION_ZERO_POINT_THREE: OpacityOption = {
  title: '0.3',
  sharpCharts2AlphaValue: '0.3'
};

export const OPACITY_OPTION_ZERO_POINT_TWO: OpacityOption = {
  title: '0.2',
  sharpCharts2AlphaValue: '0.2'
};

export const OPACITY_OPTION_ZERO_POINT_ONE: OpacityOption = {
  title: '0.1',
  sharpCharts2AlphaValue: '0.1'
};

export const OPACITY_OPTION_ZERO_POINT_ZERO: OpacityOption = {
  title: '0.0',
  sharpCharts2AlphaValue: '0.0'
};

export const DEFAULT_OPACITY_OPTION: OpacityOption = OPACITY_OPTION_ONE_POINT_ZERO;

export const OPACITY_OPTIONS_ARRAY: OpacityOption[] = [
  OPACITY_OPTION_AUTO,
  OPACITY_OPTION_ONE_POINT_ZERO,
  OPACITY_OPTION_ZERO_POINT_NINE,
  OPACITY_OPTION_ZERO_POINT_EIGHT,
  OPACITY_OPTION_ZERO_POINT_SEVEN,
  OPACITY_OPTION_ZERO_POINT_SIX,
  OPACITY_OPTION_ZERO_POINT_FIVE,
  OPACITY_OPTION_ZERO_POINT_FOUR,
  OPACITY_OPTION_ZERO_POINT_THREE,
  OPACITY_OPTION_ZERO_POINT_TWO,
  OPACITY_OPTION_ZERO_POINT_ONE,
  OPACITY_OPTION_ZERO_POINT_ZERO
];

export function getOpacityObjFromOpacityTitle(opacityTitle: string): OpacityOption {
  return OPACITY_OPTIONS_ARRAY.find(option => option.title === opacityTitle) ?? DEFAULT_OPACITY_OPTION;
}
